'use client'

import { JP_TRIAL_APPLICATION_PATH } from '@shared/routes'
import { GlobalLoadingBoundary } from '@shared/ui'
import { useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'

import { isJpTrialApplicationDismissedForSession } from './session-dismissal'

export const JpTrialHomeRedirectGate = ({
  shouldRedirect,
  userId,
}: {
  shouldRedirect: boolean
  userId: string | number
}) => {
  const router = useRouter()
  const [isResolving, setIsResolving] = useState(shouldRedirect)

  useEffect(() => {
    if (!shouldRedirect || isJpTrialApplicationDismissedForSession(userId)) {
      setIsResolving(false)
      return
    }

    router.replace(JP_TRIAL_APPLICATION_PATH)
  }, [router, shouldRedirect, userId])

  if (!isResolving) {
    return null
  }

  return (
    <>
      <div className="fixed inset-0 z-[59] bg-white" aria-hidden="true" data-testid="jp-trial-home-redirect-gate" />
      <GlobalLoadingBoundary isLoading />
    </>
  )
}
